import Speaker from './Speaker';

export default Speaker;
